module.exports = __webpack_public_path__ + "static/media/tutorial-icon.c244b84b.svg";